export default __webpack_public_path__ + "media/images/react_icons/desktop-fd641bd5edc7e05149de2e1f990bec51.svg";